module.exports = __webpack_public_path__ + "files/a6255f721c377c8b015e53b133d9d41d.woff";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/Roboto-Slab-regular.woff
// module id = 779
// module chunks = 60